import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import DrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import { PosSession } from '@pos/interfaces/pos-session';
import store from '@app/store';
import { Center } from '@core/interfaces/tenant-state';
import { appConfig } from '@/config/app-config';
import { getProp } from '@shared/helpers/operators';
import moment from 'moment';
import BpcPosSessionForm from '@pos/components/forms/pos-session-form/pos-session-form.vue';
import PosSessionForm from '@pos/components/forms/pos-session-form/pos-session-form.vue';

library.add(faSync);

@Component({
  name: 'bpc-pos-session-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': DrawerModal,
    BpcPosSessionForm,
  },
})
export default class PosSessionTable extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    reopenSessionConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
    posSessionForm: InstanceType<typeof PosSessionForm> & {
      saveEntity(): void;
      formModel: any;
    };
    stdForm: InstanceType<typeof StdForm> & {
      fetchEntityAndConfig(): void;
    };
  };
  @Prop(String) declare readonly displayConfigName: string;
  @Prop({ type: Array, default: null }) declare readonly selectConfigName: string[];
  @Prop({ type: String, default: 'default' }) readonly editFormConfigName: string;
  @Prop(String) declare readonly title: string;
  @Prop(String) declare readonly subtitle: string;

  public entity: PosSession = null;
  public entityName = 'pos-session';
  public pluralEntityName = 'pos-sessions';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;
  public permissionsEntityName = 'pos_sessions';
  public showReportModal: boolean = false;
  public isReopeningSession: boolean = false;
  public tableRenderKey: string = this.generateUUIDv4();
  public showSaveButton: boolean = true;

  isClosingSession: boolean = false;
  showCloseSessionDrawer: boolean = false;
  selectedPosSessionIdToClose: number = null;
  keyClosePosSessionForm: number = 1;
  closePosSessionFormModelLoaded: boolean = false;

  public flagsToCheckBeforeLoadEntities: string[] = [
    'configLoaded',
    'filtersLoaded',
    'paginationLoaded',
    'orderLoaded',
    'urlParametersLoaded',
  ];

  public customPageActions = {
    report: {
      activated: false,
      type: 'action',
      icon: 'chart-bar', //'times',
      variant: 'info',
      text: 'pos_report',
      show: true,
      event: 'report',
      selectElements: true,
      tag: 'middle',
      permissions: ['export'],
    },
  };

  public customRowActionsBefore = {
    reopenSession: {
      activated: false,
      type: 'action',
      icon: 'lock',
      show: false,
      event: 'reopen',
      text: 'reopen_session',
      permissions: ['reopen_pos_sessions'],
    },
    closeSession: {
      activated: false,
      type: 'action',
      icon: 'times',
      show: false,
      event: 'close-session',
      text: 'close_session',
      permissions: ['manage_pos_sessions', 'manage_own_pos_sessions'],
    },
  };

  get rowActions() {
    return {
      ...this.customRowActionsBefore,
      ...this.defaultRowActions,
      ...this.customRowActions,
    };
  }

  customOnRowAction($event: { event: string; item: any }) {
    switch ($event.event) {
      case 'reopen':
        this.openReopenSessionModal($event.item.item);
        break;
      case 'close-session':
        this.onOpenCloseSessionModal($event.item.item);
        break;
    }
  }

  onOpenCloseSessionModal(item: PosSession) {
    this.selectedPosSessionIdToClose = item.id;
    this.showCloseSessionDrawer = true;
  }
  onCloseCloseSessionModal() {
    this.selectedPosSessionIdToClose = null;
    this.isClosingSession = false;
    this.showCloseSessionDrawer = false;
  }

  onPosSessionToCloseLoaded(event) {
    setTimeout(() => {
      if (getProp(this.$refs.posSessionForm.formModel, 'status') !== 'reopened') {
        this.$set(this.$refs.posSessionForm.formModel, 'end_date', moment().format('YYYY-MM-DD'));
        this.$set(this.$refs.posSessionForm.formModel, 'end_time', moment().format('HH:mm'));
      }
      this.$set(this.$refs.posSessionForm.formModel, 'status', 'closed');
      this.closePosSessionFormModelLoaded = true;
    });
  }

  onEdit(e, disabled = false) {
    if (!this.emitOnEdit) {
      console.log('clickOnEdit', e);
      this.entity = e.item;
      this.showForm = true;
      // this.$bvModal.show('modal-resource-form');
      this.showDrawerSection = true;
      this.showSaveButton = e.item.status !== 'reopened';
      setTimeout(() => {
        this.disabledForm = disabled;
      });
    } else {
      this.$emit('on-edit', e);
    }
  }

  onNew() {
    if (!this.emitOnNew) {
      this.entity = null;
      this.showForm = true;
      // this.$bvModal.show('modal-resource-form');
      this.showDrawerSection = true;
      setTimeout(() => {
        this.disabledForm = false;
      });
      this.showSaveButton = true;
    } else {
      this.$emit('on-new');
    }
  }

  onFormSaveSession(): void {
    this.$refs.posSessionForm.saveEntity();
  }

  onClosingSession(value: boolean): void {
    this.isClosingSession = value;
  }

  onClosedSession(): void {
    this.onCloseCloseSessionModal();
    this.onRefresh();
    this.emitRefreshOpenPosSessions();
  }

  openReopenSessionModal(item) {
    this.$refs.reopenSessionConfirmationModal.onOpenModal(item.id);
  }
  closeReopenSessionModal() {
    this.$refs.reopenSessionConfirmationModal.onCloseModal();
  }

  get activatedPosV2(): boolean {
    return appConfig.modules.activatePosV2 && this.$store.getters['centerSettings/usePosV2'];
  }

  async confirmReopenSession($event) {
    const id = $event.entityIdOrIds;
    this.isReopeningSession = true;
    const posSession = await this.$posService.reopenSession(id, this.currentProfileId);
    this.emitRefreshOpenPosSessions();
    this.closeReopenSessionModal();
    this.isReopeningSession = false;
    this.$refs.provider.getEntities();
    if (this.activatedPosV2) {
      this.$router.push({
        name: 'pos-page',
        params: {
          initialPosSessionId: `${posSession.id}`,
        },
      });
    }
  }
  get reopenSessionConfirmationModalConfig() {
    return {
      id: this.entityName + '-reopen-session-modal-' + this.generateUUIDv4(),
      title: this.$t('global.modals.reopen_pos_session.title'),
      body: this.$t('global.modals.reopen_pos_session.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.confirm') as string,
      acceptButtonVariant: 'info',
    };
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as PosSession;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = false;
    this.showDrawerSection = false;
  }

  emitRefreshOpenPosSessions(): void {
    this.$store.commit('pos/clearOpenPosSession');
    this.$store.commit('pos/clearCurrentTicket');
    this.$store.dispatch('pos/getOpenPosSession');
  }

  onUpdateCashErrorAmount(closingCash) {
    if (this.$refs.stdForm) {
      const beginningCash = this.$refs.stdForm?.formModel?.beginning_cash || 0;
      const cashSales = this.$refs.stdForm?.formModel?.cash_sales || 0;
      const total_cash_movements = Number(this.$refs.stdForm?.formModel?.total_cash_movements) || 0;
      const cashError = beginningCash + cashSales + total_cash_movements - closingCash;
      this.$set(this.$refs.stdForm?.formModel, 'cash_error_amount', cashError);
    }
  }

  extendUpdateRowActions(entity: any) {
    entity.actions.softDelete.show =
      this.tableIsNotFilteredByTrashedElements() && entity.can_be_trashed;
    entity.actions.reopenSession.show =
      this.$authorizationService.hasPermission('reopen_pos_sessions') &&
      this.tableIsNotFilteredByTrashedElements() &&
      !this.currentPosSessionId &&
      entity.status === 'closed';

    const permissionToCloseSession =
      this.$authorizationService.hasPermission('manage_pos_sessions') ||
      (this.$authorizationService.hasPermission('manage_own_pos_sessions') &&
        entity.profile_id === this.currentProfileId);

    entity.actions.closeSession.show =
      permissionToCloseSession &&
      this.tableIsNotFilteredByTrashedElements() &&
      entity.status !== 'closed';

    return entity;
  }

  get currentPosSessionId() {
    return this.$store.getters['pos/openPosSessionId'];
  }

  get currentProfileId() {
    const tenant: Center = this.$store.getters['tenant/selectedTenant'];
    return this.$store.getters['auth/profile']({
      tenantId: tenant.id,
    })?.id;
  }

  onModelLoaded() {
    if (!this.$refs.stdForm.formModel.id) {
      const tentant = store.getters['tenant/selectedTenant'];
      this.$refs.stdForm.formModel.profile = store.getters['auth/profile']({
        tenantId: tentant.id,
      })?.id;
    }
  }

  refreshStdForm(event) {
    if (event.eventName == 'close_cash_movements_modal') {
      this.$refs.stdForm.fetchEntityAndConfig();
    }
  }

  // Page actions
  customOnPageAction($event: string) {
    switch ($event) {
      case 'report':
        this.openAsyncReportModal();
        break;
    }
  }

  openAsyncReportModal() {
    this.showReportModal = true;
  }

  closeAsyncReportConfirmModal() {
    this.showReportModal = false;
  }

  @Watch('currentPosSessionId')
  onChangeCurrentPOsSessionId(val) {
    this.updateRowActions();
    this.tableRenderKey = this.generateUUIDv4();
  }

  /* Lifecycle hooks */
  // created() {}
  mounted() {
    this.$root.$on('refresh-pos-session-list', () => {
      this.$refs.provider.getEntities();
    });
    this.$root.$on('update-cash-error-amount', $event => {
      this.onUpdateCashErrorAmount($event);
    });
  }
  // updated() {}

  destroyed() {
    this.$root.$off('refresh-pos-session-list');
    this.$root.$off('update-cash-error-amount');
  }
}
